import React from "react";
import { fmtCurrency } from "@/lib/api";
import { Card } from "@/components/ui/card";

export function KpiCard({ label, value, currency, delta, icon: Icon, accent = "sky", testid }) {
  const display = currency ? fmtCurrency(value) : value;
  const accents = {
    sky: "bg-sky-50 text-sky-600",
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    slate: "bg-slate-100 text-slate-600",
    rose: "bg-rose-50 text-rose-600",
  };
  return (
    <Card className="border border-slate-200/80 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 p-5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-wider font-semibold text-slate-500">{label}</p>
          <p className="mt-2 text-2xl lg:text-3xl font-bold tracking-tight text-slate-900 font-display">{display}</p>
          {delta != null && (
            <p className={`mt-1 text-xs font-medium ${delta >= 0 ? "text-emerald-600" : "text-rose-600"}`}>
              {delta >= 0 ? "▲" : "▼"} {Math.abs(delta)}% vs last period
            </p>
          )}
        </div>
        {Icon && (
          <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${accents[accent]}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </Card>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 font-display">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function EmptyState({ message, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
      <div className="h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
        <span className="text-slate-400 text-xl">○</span>
      </div>
      <p className="text-sm text-slate-500 max-w-md">{message}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
